<div class="fdx-c-form-group fdx-c-form-group--select fdx-c-form-group--float-label
fdx-c-form-group--has-value fdx-u-pl--6 fdx-o-grid__item--9@large fdx-u-mb--3 fdx-u-py--2">
  <span class="fdx-c-form-group__item">
    <select name="{{config.name}}"
      #selectedOption
      (change)="onSelect(selectedOption.value)"
      [formControl]="dropdownControl"
      class="fdx-c-form-group__select"
      id="{{config.id}}"
      [attr.aria-labelledby]="config.label">
      <ng-content select=".form-option__element"></ng-content>
    </select>

    @if (!isLoading) {
      <div class="fdx-c-form-group__icon" aria-hidden="true">
        <ciam-icon class="fdx-c-icon" aria-hidden="true" key="chevron"></ciam-icon>
      </div>
    }

    @if (isLoading) {
      <div class="fdx-c-form-group__icon fdx-u-align--right">
        <div class="fdx-c-loading-indicator fdx-c-loading-indicator--small">
          <div class="fdx-c-loading-indicator__part"></div>
          <div class="fdx-c-loading-indicator__part"></div>
          <div class="fdx-c-loading-indicator__part"></div>
          <div class="fdx-c-loading-indicator__part"></div>
        </div>
      </div>
    }

    <label class="fdx-c-form-group__label " for="{{config.id}}" id="{{config.label}}"><!--Floating label-->
      <ng-content select=".label-phone-number"></ng-content>
    </label>
  </span>
</div>
